import { X } from "lucide-react";

interface ChatTeaserProps {
  text: string;
  onOpen: () => void;
  onDismiss: () => void;
}

const ChatTeaser = ({ text, onOpen, onDismiss }: ChatTeaserProps) => (
  <div
    className="animate-fade-in bg-white rounded-xl shadow-lg px-4 py-2.5 max-w-[200px] cursor-pointer relative border border-border"
    onClick={onOpen}
  >
    <button
      onClick={(e) => {
        e.stopPropagation();
        onDismiss();
      }}
      className="absolute -top-2 -left-2 w-5 h-5 rounded-full bg-muted text-muted-foreground flex items-center justify-center text-xs hover:bg-muted/80 transition-colors"
      aria-label="Close"
    >
      <X className="w-3 h-3" />
    </button>
    <p className="text-sm text-foreground font-medium">{text}</p>
    {/* Speech bubble arrow */}
    <div className="absolute -right-2 bottom-3 w-0 h-0 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-l-[8px] border-l-white" />
    <div className="absolute -right-[9px] bottom-3 w-0 h-0 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-l-[8px] border-l-border" style={{ marginRight: '-1px' }} />
    <div className="absolute -right-2 bottom-3 w-0 h-0 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-l-[8px] border-l-white" />
  </div>
);

export default ChatTeaser;
